import classNames from "classnames"

import Typography, { TypographySize } from "./Typography"
import { Color } from "../../../constants/V2/color"

import { getBorderColorClass, getBackgroundColorClass } from "@utils/V2/color"
import React from "react"

type Props = {
  text: string
  highlightedText?: string
  textColor: Color
  accentColor: Color
  style: "solid" | "bordered" | "translucent"
  weight?: "book" | "medium"
  size?: TypographySize
  uppercaseText?: boolean
  className?: string
  isRounded?: boolean
}

const Badge = ({
  text,
  highlightedText,
  style,
  weight = "book",
  size = "subscript-lg",
  textColor,
  accentColor,
  uppercaseText = true,
  className,
  isRounded = false,
}: Props) => {
  return (
    <Typography
      text={text}
      weight={weight}
      font="grotesk"
      color={textColor}
      size={size}
      highlightedText={highlightedText}
      highlightColor={textColor}
      highlightWeight="medium"
      className={classNames(
        style !== "translucent" && getBorderColorClass(accentColor),
        style === "solid" && getBackgroundColorClass(accentColor),
        style === "translucent" && [
          getBackgroundColorClass(accentColor),
          "bg-opacity-50 backdrop-blur-[14px]",
        ],
        "w-fit px-8",
        style === "translucent" && "rounded-[6px] py-[5px]",
        style !== "translucent" && [
          "border pb-0.5 pt-4",
          isRounded ? "rounded-20" : "rounded-8",
        ],
        uppercaseText && "uppercase",
        className
      )}
    />
  )
}

export default Badge
